const host=window.location.hostname
const apiurl="https://backend.mahalrs.org"
// const apiurl="http://38.109.10.137:5558"
export {apiurl,host}